export default __webpack_public_path__ + "static/newPaymentIcons-92a72cd9579e833f5d21d3a0c4f9da60.svg";